import { Brick, registerBrick } from 'olympe';
import { toBase64 } from '@olympeio/core';

export default class SimpleEncrypt extends Brick {

    /**
     * @protected
     * @param {BrickContext} context
     * @param {string} plainText
     * @param {string} cipherKey
     * @param {function(string)} setEncryptedText
     */
    update(context, [plainText, cipherKey], [setEncryptedText]) {
        if (!cipherKey || typeof cipherKey !== 'string') {
            console.error('cipherKey is not a valid string!');
            return;
        }
        if (!plainText || typeof plainText !== 'string') {
            console.error('plainText is not a valid string!');
            return;
        }

        const plainTextLen = plainText.length;
        // First, repeat the key so that it covers all the plain text's length
        let fullKey = cipherKey;
        while (fullKey.length < plainTextLen) {
            fullKey += cipherKey;
        }

        const buffer = new ArrayBuffer(plainTextLen*2);
        const view = new Uint16Array(buffer);

        // For each character in PlainText, perform a XOR op with the key
        for (let i = 0; i < plainTextLen; i++) {
            view[i] = plainText.charCodeAt(i) ^ fullKey.charCodeAt(i);
        }

        setEncryptedText(toBase64(buffer));
    }
}

registerBrick('0178162bf27051319ac1', SimpleEncrypt);
